<template>
    <div class="chatResearch">
        <comHeader :active="active" :value="value"></comHeader>
        <div class="box">
            <div class="main_body">
                <div class="main_left">
                    <h2>{{ $t('chatlanguage.enter') }}</h2>
                    <el-input type="textarea" :rows="5" :placeholder="$t('chatlanguage.inputTips')" v-model="textarea"
                        maxlength="3500" show-word-limit>
                    </el-input>
                    <h2>{{ $t('chatlanguage.basic') }}</h2>
                    <div class="btn_s">
                        <div class="btn_" style="margin: 10px 0 20px 0">
                            <el-button @click="onResearch(5)" style="width: 48% !important" :disabled="Anti_shake"
                                size="small" type="warning">{{ $t('chatlanguage.errorChecking') }}</el-button>
                            <el-button style="width: 48% !important" :disabled="Anti_shake" @click="onResearch(1)" size="small" type="warning">{{ $t('chatlanguage.polish') }}</el-button>
                        </div>
                    </div>

                    <h2>{{ $t('chatlanguage.functionIntroduction') }}</h2>
                    <div class="introduced_">
                        <p class="introduced_txt">
                            {{ $t('chatlanguage.introduceOne') }}
                        </p>
                        <p class="introduced_txt">
                            {{ $t('chatlanguage.introduceTwo') }}
                        </p>
                    </div>
                </div>
                <div class="main_right" id="div">
                    <div style="margin: 10px 0" class="lis-css">
                        <div class="reply_list" v-for="(item, index) in list" :key="index">
                            <div class="reply_ask" v-if="item.ask">
                                <span class="span_css" style="text-align: left">
                                    {{ item.ask }}
                                </span>
                            </div>
                            <div class="reply_answer" v-if="item.answer">
                                <span class="span_css">
                                    <span v-html="item.answer" class="markdown-body"></span>
                                    <span v-if="showBlinkCursor && index + 1 == list.length" class="blinkCursor_">_</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import marked from 'marked';
import { post_chatsearch, get_chatsearch } from "@/api/classify";
import store from "@/store";
import qs from "qs";
import $ from "jquery";
import comHeader from '@/components/ComHeader.vue'
export default {
    components: { comHeader },
    data() {
        return {
            textarea: "",
            Anti_shake: false,
            list: [
                {
                    ask: "",
                    answer: "",
                    type: "",
                },
            ],
            list_copy: {
                ask: "",
                answer: "",
                type: "",
            },
            showBlinkCursor: true,
            value: ``,
            role_: "",
            active: 3,
            value: 'ChatLanguage'
        };
    },
    created() {
        if (store.getCookie("rolePermissions")) {
            this.role_ = store.getCookie("rolePermissions");
        }
    },
    computed: {
        compiledMarkdown() {
            //   const renderer = new marked.Renderer();

            //   marked.setOptions({
            //     // renderer: renderer,
            //     gfm: true,
            //     table: true,
            //     breaks: true,
            //     sanitize: false,
            //     smartypants: true,
            //   });
            return marked(this.value);
        },
    },
    methods: {
        skip_routing(type) {
            // console.log(type);
            if (type == "ChatAnswer") {
                this.$router.push({ path: "/home" });
            } else if (type == "ChatResearch") {
                this.$router.push({ path: "/chatNewResearch" });
            } else {
                this.$router.push({ path: "/chatCQUSci" });
            }
        },
        onResearch(type) {
            if (this.textarea !== "") {
                this.list[this.list.length - 1].ask = this.textarea;

                this.list[this.list.length - 1].answer = " ";

                this.list[this.list.length - 1].type = type;
                let i_s = {
                    i_con: this.textarea,
                    s_type: type,
                };
                this.showBlinkCursor = true;
                // this.stop_()
                this.Anti_shake = true;
                this.textarea = "";
                this.post_data(i_s);
                this.scrollBottm();
            } else {
                this.$message({
                    message: this.$t('chatlanguage.tips'),
                    type: "warning",
                });
            }
        },
        splicing_(txt) {
            // console.log(txt);
            if (txt) {
                this.value = txt;
                this.list[this.list.length - 1].answer = this.compiledMarkdown;
            }
        },
        post_data(data) {
            // this.splicing_(da_.delta.content);
            // this.time_(that.end_time, "end");
            // this.ce(data);
            // return
            let that = this;
            that.showBlinkCursor = true;
            let returnMessageAjax = $.ajax({
                url: this.$root.baseURL + "/api/chatsearch/qa/",
                // url: "http://192.168.66.9:7000/api/chatsearch/qa/",  //向星本地
                // url:  "http://libraryqa.newacademic.net:8001/api/chatlib/qa/",
                data: qs.stringify(data),
                timeout: 50000, // 请求超时时间
                type: "Post",
                dataType: "json",

                xhrFields: {
                    onprogress: function (e) {
                        // console.log(e);
                        let response = e.currentTarget.response;
                        // 将{"code": 400, "msg": "Token \u9a8c\u8bc1\u5931\u8d25\uff01"}转为对象
                        let obj = null
                        try {
                            obj = JSON.parse(response);
                        } catch (error) {
                            obj = null
                        }
                        if (obj && obj.code && obj.code === 400) {
                            that.$message({
                                message: obj.msg,
                                type: "error",
                            });
                            localStorage.clear()
                            sessionStorage.clear()
                            sessionStorage.setItem("quitManual", "1");
                            that.$router.push({
                                path: '/'
                            })
                        } else {
                            that.splicing_(response);
                            that.scrollBottm();
                        }
                    },
                    onload: function (e) {
                        // console.log(e);
                    },
                },
                timeout: 1000 * 60 * 2,
                headers: {
                    token: store.getCookie("Chat_token"),
                },
                complete: function (XMLHttpRequest, status) {
                    that.showBlinkCursor = false;
                    that.Anti_shake = false;
                    that.stop_();
                    // return
                    if (status === "timeout") {
                        alert(this.$t('public.overtime'));
                    } else if (status === "err") {
                        that.list[this.list.length - 2].answer = this.$t('chatlanguage.againRequest');
                    } else if (status === "parsererror") {
                    }
                },
            });
        },
        stop_() {
            let add = {
                ask: "",
                answer: "",
                type: "",
            };
            // console.log("a");
            this.list.push(add);
            console.log(this.list)
        },
        // 滚动条到底部
        scrollBottm() {
            var that = this;
            setTimeout(function () {
                const el = window.document.getElementById("div");
                // console.log(el.scrollHeight + 200);
                el.scrollTop = el.scrollHeight + 100;
            }, 50);
        },
        go_eastrans() {
            window.open("https://eastrans.newacademic.net/#/", "_blank");
        },
    },

};
</script>

<style lang='less' scoped>
.chatResearch {
    height: 100vh;
    position: relative;
    //   padding: 20px 0;
    // background-image: url("../../assets/img/背景图/小助手-05(1).jpg");
    background-size: cover;
    background-position: center center;
    cursor: pointer;
}

.box {
    margin: auto;
    width: 80%;
    max-width: 1500px;

    .chat_s {
        // text-align: center;
        text-align: left;
        // line-height: 50px;
        margin: 0 0 20px 0;

        .skip_host {
            display: inline-block;
            padding: 10px 30px 10px 30px;
            color: #444547;
            font-weight: 600;
            font-size: 20px;
        }

        .skip_sub {
            display: inline-block;
            //   width: 180px;
            padding: 10px 30px 10px 30px;
            font-size: 15px;
            font-weight: 500;
            letter-spacing: 0px;
            color: #909399;
            // line-height: 20px;
        }

        .skip_sub:hover {
            cursor: pointer;
            color: #444547;
            font-weight: 600;
        }
    }
}

.main_body {
    margin: 20px;
    display: flex;
    justify-content: space-between;
    min-height: calc(100vh - 130px);

    .main_left::-webkit-scrollbar {
        display: none;
    }

    .main_left {
        width: 33%;
        // margin: 0 10px 0 0;
        background: white;
        border-radius: 10px;
        padding: 10px;
        height: calc(100vh - 100px);
        overflow-x: hidden;
        overflow-y: scroll;
    }

    .main_right::-webkit-scrollbar {
        display: none;
    }

    .main_right {
        width: 66%;
        // margin: 0 0px 0 10px;
        background: white;
        border-radius: 10px;
        padding: 10px;
        // height: calc(100vh - 100px);
        // overflow-x: hidden;
        // overflow-y: scroll;
    }
}

.lis-css::-webkit-scrollbar {
    display: none;
}

.lis-css {
    height: calc(100vh - 140px);
    overflow-x: hidden;
    overflow-y: scroll;
}

.main_left {
    h2 {
        text-align: left;
        line-height: 35px;
        color: #444547;
        font-weight: 800;
        font-size: 16px;
        letter-spacing: 1px;
    }
}

.btn_ {
    display: flex;
    //   flex-wrap: wrap;
    justify-content: space-between;

    ::v-deep .el-button {
        width: 32% !important;
        span{
            white-space: pre-wrap;
        }
    }
}

.introduced_ {
    .introduced_txt {
        text-align: left;
        line-height: 25px;
        color: #444547;
        margin: 0 0 20px 0;
        font-size: 15px;
    }
}

.reply_list {
    .reply_ask {
        // padding: 10px;
        margin: 10px 10px 20px 10%;
        // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        text-align: right;
        // line-height: 20px;
        // // background: rgba(128, 128, 128, 0.5);
        // border-radius: 5px;
        // background: rgba(83, 163, 228, 0.2);
        // display: inline-block;
        // // display: in;
        // // color: white;
        // // background: #111827;
    }

    .reply_answer {
        // padding: 10px;
        margin: 20px 10% 10px 10px;
        // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        text-align: left;
        // width: 80%;
        // line-height: 20px;
        // background: rgba(83, 163, 228, 0.2);
    }

    .span_css {
        display: inline-block;
        padding: 10px;
        line-height: 20px;
        background: rgba(83, 163, 228, 0.2);
        border-radius: 5px;
        // margin: 10px;

        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    }
}

/deep/ .markdown-body table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    margin-bottom: 16px;
    font-size: 14px;
    line-height: 1.5;
    color: #24292e;
}

/deep/ .markdown-body td,
.markdown-body th {
    padding: 6px 13px;
    border: 1px solid #dfe2e5;
}

/deep/ .markdown-body th {
    font-weight: bold;
}

/deep/ .markdown-body thead th {
    padding: 10px 20px;
    // text-align: left;
    background-color: #f6f8fa;
    border: 1px solid #dfe2e5;
}

/deep/ .markdown-body tbody tr td {
    text-align: center;
}

/* 添加对齐方式 */
/deep/ .markdown-body td.text-left,
.markdown-body th.text-left {
    //   text-align: left;
    text-align: center;
}

/deep/ .markdown-body td.text-right,
.markdown-body th.text-right {
    //   text-align: right;
    text-align: center;
}

/deep/ .markdown-body td.text-center,
.markdown-body th.text-center {
    text-align: center;
}

/* 添加背景色 */
/deep/ .markdown-body tbody tr:nth-child(2n) {
    background-color: #f6f8fa;
}

/deep/ .markdown-body tbody tr:nth-child(2n - 1) {
    background-color: #fafafa;

}
</style>
<style>
.blinkCursor_ {
    animation: Blink 1s ease-in 0s infinite !important;
}

@keyframes Blink {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}
</style>